import React, { useState } from "react";
import { connect } from "react-redux";
import DiallerKeyPad from "./DiallerButton";
import NewCallScreen from "./NewCallScreen";
import { getAuthData } from "../../../services/storage/LocalStorage";

const Dialler = ({ 
  balance, 
  makeCall, 
  noBalance, 
  selectedDomain, 
  onClose 
}) => {
  const [showWhat, setShowWhat] = useState(null);
 const userId  = getAuthData()?.user?.userId || null;
 const emailAddress = getAuthData()?.user?.emailAddress || null;
  const makePhoneCall = async (phone, callMode) => {
    console.log("Current Balance", balance);
    if (callMode === "sat") {
      makeCall(
        "sat",
        emailAddress,
        phone,
        phone,
        null,
        null,
        "on-call"
      );
    } else {
      console.log("making phone call");
      makeCall(
        "phone",
        emailAddress,
        phone,
        phone,
        null,
        null,
        "on-call"
      );
    }
  };

  const showDialPad = () => {
    setShowWhat("on-dial-pad");
  };

  const closeDiallerPad = () => {
    setShowWhat(null);
  };

  if (!showWhat) {
    return (
      <NewCallScreen
        noBalance={() => noBalance()}
        showDialPad={showDialPad}
        selectedDomain={selectedDomain}
        onCloseDialler={onClose}
      />
    );
  } else if (showWhat === "on-dial-pad") {
    return (
      <DiallerKeyPad
        makePhoneCall={makePhoneCall}
        onClose={closeDiallerPad}
        noBalance={() => noBalance()}
      />
    );
  }
};


export default Dialler